import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParamountAuth } from 'context/ParamountAuthContext'
import { getCompanyById } from 'services/clients.svc'
import './UnderReview.scss'

export default function UnderReview() {
  const { userCompanyId } = useParamountAuth()
  
  const { data: company, isLoading } = useQuery(
    ['company', userCompanyId],
    () => getCompanyById(userCompanyId)
  )

  if (isLoading) {
    return <div aria-busy="true">Loading...</div>
  }

  return (
    <div className="under-review-container">
      <div className="status-header">
        <h1>Your Company Registration is Under Review</h1>
      </div>
      
      <div className="company-details-card">
        <h2>Submitted Details</h2>
        <div className="grid">
          <div className="details-panel">
            <label>Company Name</label>
            <p>{company.name}</p>
            <label>ABN</label>
            <p>{company.abn}</p>
            <label>Builders Registration Number</label>
            <p>{company.buildersRegNumber}</p>
            <label>Office Phone</label>
            <p>{company.phone}</p>
            <label>Office Email</label>
            <p>{company.email}</p>
            <label>Office Address</label>
            <p>{company.address}</p>
            <label>Postal Address</label>
            <p>{company.postalAddress}</p>
          </div>
        </div>
      </div>
      
      <div className="info-message">
        <h3>What happens next?</h3>
        <ul>
          <li>Our team will review your application</li>
          <li>This typically takes 1-2 business days</li>
          <li>You will receive an email notification with the outcome</li>
          <li>Once approved, you can access all platform features</li>
        </ul>
      </div>
    </div>
  )
}